import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Menu, Icon } from 'semantic-ui-react';
import { colorsModeUI } from '../../../modeUI';
import { SIZE_SMALL } from '../../../constants';
import Popup from '../popup';
import './index.css';

export const TYPE_MAIN_MENU_ITEM_LINK = 'ITEM_LINK';
export const TYPE_MAIN_MENU_ITEM = 'ITEM';

/**
 * Menu item
 * Parameters (Props):
 * @param object itemMenu: {
 *   bool active
 *   bool disable: if disable is false, the the onClick event is not called
 *   string key
 *   string icon: semantic ui icon's name
 *   object (UiIcon) uiIcon: ui-component UiIcon
 *   string colorIcon: if the color is not empty, then this value ignores the
 *                     values determined by the ui mode
 *   string type: [TYPE_MAIN_MENU_ITEM_MENU, TYPE_MAIN_MENU_ITEM_LINK, TYPE_MAIN_MENU_ITEM]
 *   func onClick
 *   bool showPopupHover: show popup window below the menuItem
 *   array popup [{ title, content }]
 *  }]
 */
export default class MenuItem extends Component {
  /**
   * Show ui icon
   * Note: the icon used in the main menu header must be small
   * @return object icon
   */
  static showUiIcon(uiIcon, color) {
    return (
      <uiIcon.type {...uiIcon.props} {...{ color }} {...{ size: SIZE_SMALL }} />
    );
  }

  constructor(props) {
    super(props);
    this.createMenuItem = this.createMenuItem.bind(this);
    this.onMouseEnter = this.onMouseEnter.bind(this);
    this.onMouseLeave = this.onMouseLeave.bind(this);
    this.styleItemMenu = this.styleItemMenu.bind(this);
    this.state = {
      hover: false,
    };
  }

  /**
   * On mouse leave
   */
  onMouseLeave() {
    this.setState({ hover: false });
  }

  /**
   * On mouse enter
   */
  onMouseEnter() {
    this.setState({ hover: true });
  }

  /**
   * Style item menu
   * @return object styleItemMenu;
   */
  styleItemMenu() {
    const { mode, itemMenu } = this.props;
    const { hover } = this.state;
    const colors = colorsModeUI(mode);
    const styleItemMenu = {};
    if (itemMenu.disable) {
      styleItemMenu.color = colors.MAIN_MENU_ITEM_DISABLE;
    } else {
      styleItemMenu.color = itemMenu.active
        ? colors.MAIN_MENU_ITEM_ACTIVE
        : colors.MAIN_MENU_ITEM_INACTIVE;
      if (hover) {
        styleItemMenu.backgroundColor = colors.MAIN_MENU_BACKGROUND_HOVER;
        styleItemMenu.color = colors.MAIN_MENU_ITEM_ACTIVE;
      }
    }
    return styleItemMenu;
  }

  /**
   * Create Menu item
   * @return object item
   */
  createMenuItem() {
    const { itemMenu, mobileVersion, mode } = this.props;
    /* style item menu - color definition */
    const styleItemMenu = this.styleItemMenu();
    const itemKey = itemMenu.key ? itemMenu.key.toString() : '';
    let item;
    switch (itemMenu.type) {
      case TYPE_MAIN_MENU_ITEM_LINK:
        item = (
          <Menu.Item
            name={itemMenu.key}
            key={itemKey}
            style={styleItemMenu}
            onMouseEnter={this.onMouseEnter}
            onMouseLeave={this.onMouseLeave}
            className="menu-item"
          >
            {itemMenu.icon && (
              <Icon
                name={itemMenu.icon}
                size="large"
                style={{ color: itemMenu.colorIcon }}
              />
            )}
            {itemMenu.uiIcon &&
              MenuItem.showUiIcon(
                itemMenu.uiIcon,
                itemMenu.colorIcon ? itemMenu.colorIcon : styleItemMenu.color
              )}
            {(!mobileVersion ||
              (mobileVersion && !itemMenu.icon && !itemMenu.uiIcon)) &&
              itemMenu.label}
          </Menu.Item>
        );
        /* add the onClick event */
        if (itemMenu.onClick && !itemMenu.disable) {
          item = (
            <item.type {...item.props} {...{ onClick: itemMenu.onClick }} />
          );
        }
        /* add the popup window */
        if (itemMenu.showPopupHover) {
          item = <Popup menuItem={item} popup={itemMenu.popup} mode={mode} />;
        }
        break;
      case TYPE_MAIN_MENU_ITEM:
        item = (
          <Menu.Item key={itemKey} style={styleItemMenu} className="menu-item">
            {itemMenu.icon && (
              <Icon
                name={itemMenu.icon}
                size="large"
                style={{ color: itemMenu.colorIcon }}
              />
            )}
            {itemMenu.uiIcon &&
              MenuItem.showUiIcon(
                itemMenu.uiIcon,
                itemMenu.colorIcon ? itemMenu.colorIcon : styleItemMenu.color
              )}
            {(!mobileVersion ||
              (mobileVersion && !itemMenu.icon && !itemMenu.uiIcon)) &&
              itemMenu.label}
          </Menu.Item>
        );
        break;
      default:
        item = {};
    }

    return item;
  }

  render() {
    return this.createMenuItem();
  }
}

MenuItem.propTypes = {
  itemMenu: PropTypes.shape({
    active: PropTypes.bool,
    disable: PropTypes.bool,
    key: PropTypes.string,
    icon: PropTypes.string,
    uiIcon: PropTypes.node,
    colorIcon: PropTypes.string,
    type: PropTypes.string,
    label: PropTypes.string,
    onClick: PropTypes.func,
    showPopupHover: PropTypes.bool,
    popup: PropTypes.objectOf(
      PropTypes.shape({
        title: PropTypes.string,
        content: PropTypes.object,
      })
    ),
  }).isRequired,
  mobileVersion: PropTypes.bool,
  mode: PropTypes.string,
};

MenuItem.defaultProps = {
  mobileVersion: false,
  mode: null,
};
